import { useContext, useMemo } from 'react'
import ProductShelfSkeleton from 'src/components/skeletons/ProductShelfSkeleton'
import { getResponsiveVisibility } from 'src/utils/getResponsiveVisibility'

import { RecommendationContext } from '../../contexts/Recommendations/recommendations-context'
import type {
  DataRecommendation,
  Showcases,
} from '../../types/linx-recommendations'
import ShelfV2 from '../ShelfV2/ShelfV2'

type GenericShelfV2Props = {
  position: keyof typeof POSITION_MAP
  enableSession?: boolean
  engine: 'dy'
  type?: string
  shelfServerData?: DataRecommendation[]
  showOnDesktop?: boolean
  showOnMobile?: boolean
}

export const POSITION_MAP = {
  topo: 'top',
  top: 'top',
  middle: 'middle',
  meio: 'middle',
  baixo: 'bottom',
  bottom: 'bottom',
  'area bonus': 'area-bonus',
  'area-bonus': 'area-bonus',
}

const renderShelves = ({
  showCases,
  type,
  engine,
}: {
  showCases: Showcases[]
  type?: string
  engine: 'dy'
}) => {
  return showCases.map(
    ({ id, title, name, displays, decisionId }: Showcases) => (
      <ShelfV2
        engine={engine}
        key={id}
        {...{ title, name, decisionId }}
        products={displays[0].recommendations}
        type={type}
        id={id}
      />
    )
  )
}

const GenericShelfV2 = ({
  position,
  enableSession = true,
  type,
  engine = 'dy',
  shelfServerData = [],
  showOnDesktop,
  showOnMobile,
}: GenericShelfV2Props) => {
  const { dyDataRecommendations, error, loading } = useContext(
    RecommendationContext
  )

  const visibilityClasses = useMemo(() => {
    return getResponsiveVisibility(showOnDesktop, showOnMobile)
  }, [showOnDesktop, showOnMobile])

  if (!enableSession || error) {
    return null
  }

  const recommendation: DataRecommendation[] | null = Array.isArray(
    dyDataRecommendations
  )
    ? dyDataRecommendations
    : null

  const shelfData =
    recommendation?.filter(
      (item: DataRecommendation) =>
        item.position === POSITION_MAP[position] && item.showcases?.length
    ) || []

  const showCases =
    (recommendation
      ? shelfData[0]?.showcases
      : shelfServerData[0]?.showcases) || []

  if (loading && !shelfServerData.length) {
    return (
      <div
        className={`w-full max-w-[1280px] mx-auto ${visibilityClasses} max-h-[437px] md:max-h-[652px]`}
      >
        <ProductShelfSkeleton />
      </div>
    )
  }

  return showCases.length ? (
    <div className={`${visibilityClasses}`}>
      {renderShelves({ showCases, type, engine })}
    </div>
  ) : null
}

export default GenericShelfV2
